/**
 * Abstract API client provider class.
 *
 * @typeparam TClient The type of the API client.
 * @typeparam TConfig The type of the configuration required to update the API client.
 */
export class ApiClientProvider {
    constructor() {
        this.client = undefined;
    }
    get instance() {
        if (!this.client) {
            throw new Error('API client has not been initialised. Ensure the initialise() function has been called on page load.');
        }
        return this.client;
    }
}
